/**
 * Derive the avatar URL for an agent from its display name (e.g. "@yagni" → "/avatars/yagni.png").
 * Returns null if no matching avatar exists. Callers render an initial-bubble fallback.
 */
export function getAgentAvatarUrl(agentName: string): string | null {
  const id = agentName.replace(/^@/, "").toLowerCase();
  return id === "yagni" ? "/avatars/yagni.png" : null;
}
